import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/index.css";

const root = createRoot(document.getElementById("root")!);

console.log("booted");
document.body.style.background = "#111";
document.body.style.color = "#fff";

root.render(<App />);